import { cn } from '@discover-lib/utils';

export type EmptyMessageTitleProps = {
  className?: string;
};

export default function EmptyMessageTitle({ className }: EmptyMessageTitleProps) {
  return <h2 className={cn('m-0', className)}>Oops, we didn&apos;t find a match</h2>;
}
